<script>
export default {
  name: 'AiCatalogApp',
};
</script>

<template>
  <router-view />
</template>
